// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100vh;
  color: white;
}

.App-header {
  padding: 2rem;
  background: rgba(0, 0, 0, 0.1);
}

.App-header h1 {
  margin: 0 0 0.5rem 0;
  font-size: 2.5rem;
}

.App-header p {
  margin: 0;
  opacity: 0.9;
  font-size: 1.1rem;
}

.App-main {
  padding: 2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.section {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 1.5rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 1rem;
  margin: 1rem 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.button {
  background: linear-gradient(45deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: transform 0.2s;
  margin: 0.5rem;
}

.button:hover {
  transform: translateY(-2px);
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1rem;
  margin: 0.5rem 0;
}

.input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.textarea {
  min-height: 120px;
  resize: vertical;
  font-family: 'Courier New', monospace;
}

.success {
  color: #4ade80;
  font-weight: 600;
}

.error {
  color: #f87171;
  font-weight: 600;
}

.loading {
  color: #fbbf24;
  font-weight: 600;
}

.token-display {
  background: rgba(0, 0, 0, 0.2);
  padding: 1rem;
  border-radius: 8px;
  word-break: break-all;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  margin: 1rem 0;
}

.json-display {
  background: rgba(0, 0, 0, 0.3);
  padding: 1rem;
  border-radius: 8px;
  text-align: left;
  font-family: 'Courier New', monospace;
  font-size: 0.85rem;
  overflow-x: auto;
  white-space: pre-wrap;
}

@media (max-width: 768px) {
  .container {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .App-header h1 {
    font-size: 2rem;
  }
  
  .App-main {
    padding: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".App {\n  text-align: center;\n  min-height: 100vh;\n  color: white;\n}\n\n.App-header {\n  padding: 2rem;\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.App-header h1 {\n  margin: 0 0 0.5rem 0;\n  font-size: 2.5rem;\n}\n\n.App-header p {\n  margin: 0;\n  opacity: 0.9;\n  font-size: 1.1rem;\n}\n\n.App-main {\n  padding: 2rem;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n}\n\n.section {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 15px;\n  padding: 1.5rem;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.card {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  padding: 1rem;\n  margin: 1rem 0;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.button {\n  background: linear-gradient(45deg, #667eea, #764ba2);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 600;\n  transition: transform 0.2s;\n  margin: 0.5rem;\n}\n\n.button:hover {\n  transform: translateY(-2px);\n}\n\n.button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  font-size: 1rem;\n  margin: 0.5rem 0;\n}\n\n.input::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.textarea {\n  min-height: 120px;\n  resize: vertical;\n  font-family: 'Courier New', monospace;\n}\n\n.success {\n  color: #4ade80;\n  font-weight: 600;\n}\n\n.error {\n  color: #f87171;\n  font-weight: 600;\n}\n\n.loading {\n  color: #fbbf24;\n  font-weight: 600;\n}\n\n.token-display {\n  background: rgba(0, 0, 0, 0.2);\n  padding: 1rem;\n  border-radius: 8px;\n  word-break: break-all;\n  font-family: 'Courier New', monospace;\n  font-size: 0.9rem;\n  margin: 1rem 0;\n}\n\n.json-display {\n  background: rgba(0, 0, 0, 0.3);\n  padding: 1rem;\n  border-radius: 8px;\n  text-align: left;\n  font-family: 'Courier New', monospace;\n  font-size: 0.85rem;\n  overflow-x: auto;\n  white-space: pre-wrap;\n}\n\n@media (max-width: 768px) {\n  .container {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .App-header h1 {\n    font-size: 2rem;\n  }\n  \n  .App-main {\n    padding: 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
